export const autoCompleteBundlesConfig = {
    parts: false,
    components: false,
    host: true,
};
export const autoCompleteConventions = {
    getComponentName: ({ componentName }) => componentName,
    patterns: [
        {
            part: 'autoComplete',
            path: '{,*/}%ComponentName%/corvid/%ComponentName%.autoComplete.ts',
        },
    ],
};
//# sourceMappingURL=autoComplete.js.map